import {ReactNode} from 'react';
import cx from 'classnames';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {Divider} from '~library/atoms/Divider';
import {SkipButton} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/SkipButton';

import './Header.sass';

type HeaderProps = {
  title?: ReactNode;
  onClose?: () => void;
  onSkip?: () => void;
  titleLeftAligned?: boolean;
  showSkipButton?: boolean;
};

export const Header = ({title, onClose, showSkipButton, titleLeftAligned, onSkip}: HeaderProps) => {
  const isLargishAndUp = useIsLargishAndUp();
  return (
    <div>
      <div className="rsvp-header">
        <div
          className={cx('rsvp-header__title__wrapper', {
            'rsvp-header__title__wrapper--leftAligned': titleLeftAligned,
          })}
        >
          {title && (
            <Typography
              variant={isLargishAndUp ? 'header2' : 'header3'}
              classNames="rsvp-header__title"
            >
              {title}
            </Typography>
          )}
        </div>

        {!showSkipButton && onClose && (
          <Button
            variant="unstyled-button"
            onClick={onClose}
            data-qa-id="close-button"
            className="rsvp-header__close-button"
          >
            <CloseLineIcon ratio={0.75} />
          </Button>
        )}

        {showSkipButton && onSkip && <SkipButton onClick={onSkip} />}
      </div>

      {!isLargishAndUp && title && <Divider marginTop="1rem" />}
    </div>
  );
};
